// @flow strict

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { MicroFrontEnds } from '../../microfrontendURIs';

import MicroFrontend from '..';
import { ContainerCentered } from 'styles/common';
import ErrorMessage from 'components/ErrorMessage';
import type { ImmutableUser } from 'services/Authentication/types';
import type { IntlType } from 'types';
import { selectUser, selectUserTimezone } from 'services/Authentication/selectors';
import { canAccessMinChemMfe } from '../../utils/authentication';

type Props = {
    intl: IntlType,
    user: ImmutableUser,
    userTimezone: string,
};

type State = {
    isUnLoadable: boolean,
};

class MinChemV2 extends React.PureComponent<Props, State> {
    state = {
        isUnLoadable: false,
    };

    static getHost = () => {
        return MicroFrontEnds.minChem; // name must match the secret object's structure in GCP
    };

    static getUniqueName = () => {
        return 'MinChemMFE'; // name must match the container name in the MFE code
    };

    getMountProps = () => {
        return {
            locale: this.props.intl.locale.toUpperCase(),
            userRoles: [...new Set(this.props.user.get('roles'))],
            userTimezone: this.props.userTimezone,
        };
    };

    onError = () => {
        this.setState({ isUnLoadable: true });
    };

    render() {
        if(!canAccessMinChemMfe(this.props.user)) {
            return (
                <ContainerCentered>
                    <ErrorMessage
                        errorMessage={this.props.intl.formatMessage({
                            id: `views.${MinChemV2.getUniqueName()}.userNotAuthorized`,
                        })}
                    />
                </ContainerCentered>
            );
        }
        if (this.state.isUnLoadable) {
            return (
                <ContainerCentered>
                    <ErrorMessage
                        errorMessage={this.props.intl.formatMessage({
                            id: `views.${MinChemV2.getUniqueName()}.anErrorOccurredDuringLoad`,
                        })}
                    />
                </ContainerCentered>
            );
        }
        return (
            <MicroFrontend
                name={MinChemV2.getUniqueName()}
                host={MinChemV2.getHost()}
                mountedMicroFrontendProps={this.getMountProps()}
                onError={this.onError}
                mfeIsInFullScreen
            />
        );
    }
}

const mapStateToProps = () =>
    createStructuredSelector({
        user: selectUser(),
        userTimezone: selectUserTimezone(),
    });

export default connect(mapStateToProps)(injectIntl(MinChemV2));
